module.exports = __webpack_public_path__ + "d0966b54111bb6f10e80b434488a65e0.png";